var Hack = {
  ASTERISK: 'asterisk',
  BANG: 'bang',
  BACKSLASH: 'backslash',
  UNDERSCORE: 'underscore'
};

module.exports = Hack;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/optimizer/hack.js
// module id = 672
// module chunks = 0